import {   Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';


@Directive({
  selector: '[appNumberOnly]',
  standalone: true
})
export class NumberOnly implements OnInit {

  private currentElement: HTMLInputElement | null = null;
  private nextSibling: HTMLInputElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {

    this.currentElement = this.el.nativeElement;
    this.nextSibling = this.currentElement!.nextElementSibling as HTMLInputElement;
  }

  @HostListener('keyup')
  onKeyUp() {

    const value = this.currentElement!.value;

    const num = parseInt(value!);

    if( value!.trim().length > 0 && isNaN(num)){

      this.renderer.setProperty(this.currentElement, 'value', '');
    }else{

      if (this.nextSibling && typeof this.nextSibling.focus === 'function' && value!.length > 0) {
        this.nextSibling.focus();
        this.nextSibling.select();
      }
    }

  }

  @HostListener('click')
  onClick() {

    this.currentElement!.value = '';
  }
}
